
// might want to pull this in via json???

export const AvailableCategories = [
  {
    id: '42',
    url: 'driver-safety',
    name: 'Driver Safety'
  },
  {
    id: '73',
    url: 'corrective-action',
    name: 'Corrective Action'
  },
  {
    id: '43',
    url: 'workplace-safety',
    name: 'Workplace Safety'
  },
  {
    id: '44',
    url: 'leadership-development',
    name: 'HR/Leadership Development'
  },
  {
    id: '49',
    url: 'health-wellness',
    name: 'Health & Wellness'
  },
  {
    id: '55',
    url: 'church-safety',
    name: 'Church Safety'
  },
  {
    id: '58',
    url: 'dot-compliance',
    name: 'DOT Compliance'
  }

]
